<template>
  <div class="content-body">
    <h4 class="page-title">Users List</h4>
    <nav class="d-flex-center border-bottom m-b-20">
      <div class="nav nav-tabs custom-tabs mr-auto">
        <a
          class="nav-item nav-link"
          :class="{ active: !user_role }"
          @click.prevent="switchRoleTabs(0)"
          >All Users<span>({{ total_count }})</span>
        </a>
        <a
          class="nav-item nav-link"
          v-for="role in roles_tab"
          :class="{ active: user_role == role.name }"
          @click.prevent="switchRoleTabs(role.name)"
          >{{ role.name | capitalize }}s<span>({{ role.users_count }})</span>
        </a>
      </div>
    </nav>
    <!-- End nav -->
    <div class="table-wrapper">
      <div class="card mb-0 m-t-30 d-flex-center table-header">
        <div class="mr-auto d-flex-center table-header-left">
          <div class="d-flex-center m-5">
            <div class="select-wrapper select-bulk-wrapper">
              <select name="bulk-box" v-model="bulk_action">
                <option value>Bulk Action</option>
                <option v-if="can_do.delete" value="trash">Trash</option>
              </select>
            </div>
            <button
              class="secondary-btn btn-small btn-bulk"
              @click="run_bulk_action_submit"
            >
              Submit
            </button>
          </div>
          <div class="input-wrapper m-5 search-box">
            <input
              v-model="search"
              @input="awaitingSearch = true"
              name="search"
              type="text"
              placeholder="Search"
            />
            <i class="far fa-search"></i>
          </div>
          <div class="select-wrapper m-5">
            <select
              name="user-data-status"
              @change.prevent="onChangeDataStatus"
              id="user-data-status"
              v-model="user_data_status"
            >
              <option value="1">Active</option>
              <option value="2">Trash</option>
            </select>
          </div>
        </div>
        <a
          href="javascript:void(0)"
          v-if="can_do.add_users"
          @click.prevent="openModalForm(0)"
          class="primary-btn btn-small m-5 text-capitalize"
        >
          <i class="far fa-plus"></i> Add User
        </a>
      </div>
      <div class="table-responsive">
        <table
          class="table common-table has-checkbox action-right"
          :class="{ 'loading-content-by-axios': loading_data }"
        >
          <thead>
            <tr>
              <th>
                <div class="custom-checkbox">
                  <input
                    type="checkbox"
                    id="select-all1"
                    v-model="isAllMaredAsChecked"
                    @click="markedAllChecked"
                  />
                  <label for="select-all1"></label>
                </div>
              </th>
              <th
                v-for="(column, column_key) in columns"
                :key="column"
                @click="sortByColumn(column_key)"
              >
                {{ column }}
                <span v-if="column_key === sortedColumn">
                  <i v-if="order === 'asc'" class="fas fa-arrow-up"></i>
                  <i v-else class="fas fa-arrow-down"></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class v-if="tableData.length === 0">
              <td
                class="lead text-center"
                :colspan="Object.keys(columns).length + 1"
              >
                No data found.
              </td>
            </tr>
            <tr
              v-for="(data, key1) in tableData"
              :key="data.id"
              class="m-datatable__row"
              v-else
            >
              <td>
                <div class="custom-checkbox">
                  <input
                    v-if="data.id"
                    type="checkbox"
                    :value="data.id"
                    v-model="bulk_selected"
                    :id="data.id"
                    @change="markedAllCheckedUpdate()"
                  />
                  <label :for="data.id"></label>
                </div>
              </td>
              <td>
                <div class="d-flex-center">
                  <div
                    class="avatar-img"
                    :style="{ backgroundImage: 'url(' + data.avatar + ')' }"
                  ></div>
                  <div class="v-avatar-content">{{ data.name }}</div>
                </div>
              </td>
              <td>{{ data.email }}</td>
              <td>{{ data.role | capitalize }}</td>
              <td>
                <div class="single-btn-group d-inline-flex">
                  <button
                    type="button"
                    class="btn btn-link btn-download"
                    v-if="data.action.edit && data.data_status == 1"
                    @click.prevent="openModalForm(data.id)"
                  >
                    <i class="far fa-edit"></i> Edit
                  </button>
                  <button
                    type="button"
                    class="btn btn-link btn-download"
                    @click.prevent="deleteRecord(data.id,0)"
                    v-if="data.action.delete && data.data_status == 1"
                  >
                    <i class="far fa-trash"></i> Trash
                  </button>
                    <button
                        type="button"
                        class="btn btn-link btn-download"
                        @click.prevent="undoDeleteUser(data.id)"
                        v-if="data.data_status == 0">
                        <i class="far fa-undo-alt"></i> Restore
                    </button>
                    <button
                        type="button"
                        class="btn btn-link btn-download"
                        @click.prevent="deleteRecord(data.id,1)"
                        v-if="data.action.delete && data.data_status == 0">
                        <i class="fal fa-times-circle"></i>Permanent Delete
                    </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex-center">
        <pagination
          :page-count="pagination.last_page"
          :click-handler="setPagination"
          :container-class="'pagination m-0'"
          :page-class="'page-item'"
          ref="pagination"
        ></pagination>
        <div class="select-wrapper select-per-page ml-auto ml-auto">
          <select
            v-model="perPage"
            @change="onChangePerPage"
            class="result-filter"
          >
            <option v-for="(la, lk) in limit_array" :value="lk">
              {{ la }}
            </option>
          </select>
        </div>
        <!-- End .select-per-page -->
      </div>
    </div>
    <modal-form ref="modalform"></modal-form>
  </div>
</template>


<script>
const Swal = require("sweetalert2");
export default {
  props: {
    fetchUrl: { type: String, required: true },
    deleteUrl: { type: String, required: true },
    undeleteUrl: { type: String, required: true },

    columns: { type: Object, required: true },
    sortable_columns: { type: Array },

    totalCount: { type: Number, default: 0 },
    limit: { type: Number, default: 10 },
    limit_array: { type: Object, default: {} },
    can_do: { type: Object, required: true },
    roles: { type: Array, required: true },
  },
  data() {
    return {
      tableData: [],
      data_url: "",
      delete_route: "",
      get_edit_route: "",
      roles_tab: {},
      total_count: 0,
      pagination: { to: 1, from: 1, current_page: 1, last_page: 1 },
      search: "",
      awaitingSearch: false,
      perPage: 10,
      sortedColumn: "name",
      order: "asc",
      user_role: 0,
      extra_params: {},

      bulk_selected: [],
      isAllMaredAsChecked: false,
      bulk_action: "",
      loading_data: false,
      user_data_status: 1,
      trash_alert:Laravel.trash_alert,
      delete_alert:Laravel.delete_alert,
    };
  },
  watch: {
    fetchUrl: {
      handler: function (fetchUrl) {
        this.data_url = fetchUrl;
      },
      immediate: true,
    },
    limit: {
      handler: function (data) {
        this.perPage = data;
      },
      immediate: true,
    },
    deleteUrl: {
      handler: function (fetchUrl) {
        this.delete_route = fetchUrl;
      },
      immediate: true,
    },
    getEditUrl: {
      handler: function (fetchUrl) {
        this.get_edit_route = fetchUrl;
      },
      immediate: true,
    },
    totalCount: {
      handler: function (value) {
        this.total_count = value;
      },
      immediate: true,
    },

    roles: {
      handler: function (data) {
        this.roles_tab = data;
      },
      immediate: true,
    },

    search: _.debounce(function () {
      this.fetchData();
    }, 1500),
    awaitingSearch: function (value) {
      if (!value) {
        this.fetchData();
      }
    },
  },
  created() {
    return this.fetchData();
  },
  computed: {},
  methods: {
    onChangeDataStatus: function () {
      this.fetchData();
    },
    fetchData: function () {
      var params = {
        page: this.pagination.current_page,
        column: this.sortedColumn,
        order: this.order,
        per_page: this.perPage,
        role: this.user_role,
      };

      if (this.extra_params) {
        params = Object.assign({}, this.extra_params, params);
      }

      if (this.search) {
        params.q = this.search;
      }

      if (this.user_data_status) {
        params.user_data_status = this.user_data_status;
      }
      this.loading_data = true;
      axios
        .get(this.data_url, {
          params: params,
        })
        .then(({ data }) => {
          this.loading_data = false;
          this.pagination = data.meta;
          this.tableData = data.data;
          if (data.roles) {
            this.roles_tab = data.roles;
          }
          if (data.total_count) {
            this.total_count = data.total_count;
          }
        })
        .catch((error) => this.$throwSwalError(error));
    },
    deleteData: function (params) {
      var _this = this;
      axios
        .post(this.delete_route, params)
        .then(({ data }) => {
          this.extra_params.load_counter = true;
          this.fetchData();
          this.isAllMaredAsChecked = false;
          this.bulk_selected = [];
        })
        .catch(function (error) {
          _this.$throwSwalError(error);
        });
    },
    openModalForm: function (id) {
      this.$refs.modalform.openModal(id);
      this.record_id = id;
      this.showModal = true;
    },
    switchRoleTabs: function (role) {
      this.pagination.current_page = 0;
      this.$refs.pagination.handlePageSelected(1);
      this.user_role = role;
      this.fetchData();
    },
    onChangePerPage: function () {
      this.pagination.current_page = 0;
      this.$refs.pagination.handlePageSelected(1);
      this.fetchData();
    },
    setPagination: function (page) {
      this.pagination.current_page = page;
      this.fetchData();
    },

    /**
     * Delete record
     * **/
    deleteRecord: function (id, type) {
      if (id) {
          var message = this.trash_alert;
          if (type){
              message = this.delete_alert;
          }
        Swal.fire({
            title: "Are you sure?",
            text: message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then((action) => {
          if (action.isConfirmed) {
            var params = {};
            params.action = "trash";
            params.type = type;
            params.ids = id;
            this.deleteData(params);
          }
        });
      }
    },

    undoDeleteUser: function (id) {
      if (id) {
        Swal.fire({
          title: "Are you sure?",
          text: "Once restore, the account will be visable to all",
          icon: "warning",
          showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then((action) => {
          if (action.isConfirmed) {
            var params = {};
            params.ids = id;
            this.undoDeleteUserNow(params);
          }
        });
      }
    },

    undoDeleteUserNow: function (params) {
      var _this = this;
      axios
        .post(this.undeleteUrl, params)
        .then(({ data }) => {
          this.extra_params.load_counter = true;
          this.fetchData();
        })
        .catch(function (error) {
          _this.$throwSwalError(error);
        });
    },
    /**
     * bulk actions
     **/
    run_bulk_action_submit: function () {
      if (this.bulk_action && Object.keys(this.bulk_selected).length) {
          var type = 0;
          var message = this.trash_alert;
          if (this.user_data_status == 2){
              message = this.delete_alert;
              type = 1;
          }

        Swal.fire({
          title: "Are you sure?",
          text: message,
          icon: "warning",
          showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then((action) => {
          if (action.isConfirmed) {
            var params = {};
            params.action = this.bulk_action;
            params.ids = this.bulk_selected;
            params.type = type;
            this.deleteData(params);
          }
        });
      }
    },
    markedAllChecked: function () {
      this.bulk_selected = [];
      if (!this.isAllMaredAsChecked) {
        for (let i in this.tableData) {
          this.bulk_selected.push(this.tableData[i].id);
        }
      }
    },
    markedAllCheckedUpdate: function () {
      if (this.tableData.length == this.bulk_selected.length) {
        this.isAllMaredAsChecked = true;
      } else {
        this.isAllMaredAsChecked = false;
      }
    },
    /**
     * Sort the data by column.
     * */
    sortByColumn(column) {
      if (_.includes(this.sortable_columns, column)) {
        if (column === this.sortedColumn) {
          this.order = this.order === "asc" ? "desc" : "asc";
        } else {
          this.sortedColumn = column;
          this.order = "asc";
        }
        this.fetchData();
      }
    },
  },
  filters: {
    columnHead(value) {
      return value.split("_").join(" ").toUpperCase();
    },
  },
  components: {
    pagination: require("../../components/pagination").default,
    "modal-form": require("./ModalForm").default,
  },
  name: "DataTable",
};
</script>
